import { type HTMLAttributes, type Ref } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const itemMediaVariants = cva(
  "flex shrink-0 items-center justify-center gap-2 group-has-[[data-slot=item-description]]/item:translate-y-0.5 group-has-[[data-slot=item-description]]/item:self-start [&_svg]:pointer-events-none",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        icon: "h-10 w-10 rounded-md border border-border bg-muted [&_svg:not([class*='size-'])]:h-5 [&_svg:not([class*='size-'])]:w-5",
        image: "h-10 w-10 overflow-hidden rounded-sm [&_img]:h-full [&_img]:w-full [&_img]:object-cover",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface ItemMediaProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof itemMediaVariants> {
  ref?: Ref<HTMLDivElement>;
}

export const ItemMedia = ({ className, variant, ref, ...props }: ItemMediaProps) => (
  <div
    ref={ref}
    data-slot="item-media"
    data-variant={variant ?? "default"}
    className={cn(itemMediaVariants({ variant }), className)}
    {...props}
  />
);

export { itemMediaVariants };
